export default __webpack_public_path__ + "static/media/lang.6725102e.svg";